module.exports = __webpack_public_path__ + "img/cd-the-factory-bloc.00395263.jpg";